import { render, staticRenderFns } from "./IconAssessmentReview.vue?vue&type=template&id=e29d608e"
import script from "./IconAssessmentReview.vue?vue&type=script&lang=js"
export * from "./IconAssessmentReview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports